import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

export const initMixpanel = () => {
  if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: true,
      track_pageview: true,
    });
  } else {
    console.warn("Mixpanel not initialized: missing token or window");
  }
};

export const identifyUser = (user) => {
  if (user?._id || user?.email) {
    mixpanel.identify(user._id || user.email);
    mixpanel.people.set({
      $email: user.email,
      $first_name: user.first_name,
      $last_name: user.last_name,
      role: user.role,
    });
  }
};

export const trackEvent = (event, properties = {}) => {
  mixpanel.track(event, properties);
};
